import { Users, Dumbbell, Salad, HeartPulse, ArrowUpRight } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";
import { scrollToId } from "../../lib/scroll";

const SERVICES = [
  {
    icon: Users,
    title: "Group Fitness",
    desc: "Stay active, motivated and accountable through fun, challenging group workouts that welcome every fitness level.",
    span: "md:col-span-7",
    img: "/photos/group-fitness.jpg",
    alt: "Me 1st Fitness group class having fun mid-workout in the Red Deer studio",
  },
  {
    icon: Dumbbell,
    title: "Fitness Coaching",
    desc: "Personalized fitness guidance designed around your goals, your current fitness level and your lifestyle.",
    span: "md:col-span-5",
    img: "/photos/fitness-coaching.jpg",
    alt: "Member showing off a Workout Like a Girl tank inside the Me 1st Fitness studio",
  },
  {
    icon: Salad,
    title: "Nutrition Coaching",
    desc: "Practical nutrition guidance focused on building sustainable habits — not extreme diets or guilt.",
    span: "md:col-span-5",
    img: "/photos/nutrition.jpg",
    alt: "Fresh tacos with cilantro and lime — real food, sustainable nutrition coaching",
  },
  {
    icon: HeartPulse,
    title: "Fitness & Nutrition Coaching",
    desc: "A combined approach that brings training, nutrition, accountability and healthy habits together.",
    span: "md:col-span-7",
    img: "https://images.unsplash.com/photo-1667499745120-f9bcef8f584e?auto=format&fit=crop&w=1400&q=85",
    alt: "Colourful healthy meal prep representing nutrition coaching",
  },
];

const Card = ({ s, i }) => (
  <Reveal delay={0.08 * i} className={s.span}>
    <article
      className={`group relative h-full rounded-3xl border border-black/5 p-8 sm:p-10 overflow-hidden flex flex-col justify-between min-h-[19rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-colors duration-500 ${
        s.img ? "text-sand" : "bg-white text-charcoal hover:bg-sand-dark"
      }`}
      data-testid={`service-card-${i}`}
    >
      {s.img && (
        <>
          <img
            src={s.img}
            alt={s.alt}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-charcoal/60 transition-colors duration-500 group-hover:bg-charcoal/50" />
        </>
      )}
      <div className="relative">
        <span
          className={`w-12 h-12 rounded-full flex items-center justify-center ${
            s.img ? "bg-sand/15 backdrop-blur" : "bg-brand/15"
          }`}
        >
          <s.icon size={22} className={s.img ? "text-brand" : "text-brand-dark"} />
        </span>
        <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mt-6">{s.title}</h3>
        <p className={`mt-3 leading-relaxed max-w-md ${s.img ? "text-sand/85" : "text-charcoal/65"}`}>
          {s.desc}
        </p>
      </div>
      <button
        onClick={() => scrollToId("programs")}
        data-testid={`service-learn-more-btn-${i}`}
        className={`relative mt-8 self-start inline-flex items-center gap-2 font-bold text-sm tracking-wide rounded-full px-6 py-3 transition-colors duration-300 ${
          s.img
            ? "bg-sand text-charcoal hover:bg-brand"
            : "bg-charcoal text-sand hover:bg-brand hover:text-charcoal"
        }`}
      >
        LEARN MORE
        <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </button>
    </article>
  </Reveal>
);

const Services = () => (
  <section id="services" className="py-24 sm:py-32 bg-mint" data-testid="services-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
        <ChapterHeading number="02" label="Services" title="Coaching That Fits Your Life" />
        <Reveal delay={0.15}>
          <p className="max-w-sm text-charcoal/60 leading-relaxed lg:text-right">
            Four ways to work with Me 1st Fitness &amp; Coaching — pick the lane that fits your
            life, or blend them together.
          </p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
        {SERVICES.map((s, i) => (
          <Card key={s.title} s={s} i={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Services;
